import Joi from "joi-browser";
import { useMemo, useState } from "react";
import { putTTSSettings } from "../../service";
import Form from "V2.0/components/Form";
import { message } from "antd";

// Loudness controls for Superdash TTS2 (OmniVoice) voices only. The omni
// server synthesizes the full utterance before streaming, so it can measure
// and normalize loudness server-side; the VoxCPM (TTS1) server streams while
// generating and cannot, which is why it has no settings panel.

const template = [
  {
    name: "loudnessNormalize",
    label: "Loudness Normalization",
    type: "toggle",
    description:
      "Automatically level every reply to the target loudness so all voices come out at a consistent volume.",
  },
  {
    name: "targetLufs",
    label: "Target Loudness (LUFS)",
    type: "slider",
    min: -40,
    max: -5,
    step: 1,
    description: "-16 suits conversational voice. Lower is quieter.",
  },
  {
    name: "gainDb",
    label: "Gain (dB)",
    type: "slider",
    min: -30,
    max: 30,
    step: 1,
    description: "Fixed volume adjustment applied after normalization. 0 = off.",
  },
];

const schema = {
  loudnessNormalize: Joi.boolean().required().label("Loudness Normalization"),
  targetLufs: Joi.number().min(-40).max(-5).required().label("Target Loudness"),
  gainDb: Joi.number().min(-30).max(30).required().label("Gain"),
};

export default function SuperdashTTS2(props) {
  const {
    superdashtts2Settings,
    ttsServiceProvider,
    syncAssistant,
    workspaceId,
    assistantId,
    onClose,
  } = props;

  const [loading, setLoading] = useState(false);

  const inputField = useMemo(() => {
    return {
      loudnessNormalize: superdashtts2Settings?.loudnessNormalize ?? false,
      targetLufs: superdashtts2Settings?.targetLufs ?? -16,
      gainDb: superdashtts2Settings?.gainDb ?? 0,
    };
  }, [superdashtts2Settings]);

  const handleSaveSettings = async (data) => {
    setLoading(true);
    message.loading("Saving");

    const payload = {
      ttsServiceProvider,
      superdashtts2Settings: data,
    };

    try {
      const response = await putTTSSettings({
        workspaceId,
        assistantId,
        payload,
      });

      if (response.status === 200) {
        message.destroy();
        setLoading(false);
        message.success("Saved");
        syncAssistant((prevAssistant) => {
          return { ...prevAssistant, ttsSettings: response.data };
        });
        onClose();
      }
    } catch (e) {
      setLoading(false);

      message.destroy();
      message.error(
        e.response.data?.msg ||
          e.response.data?.message ||
          e.response.data?.error ||
          "Failed to save settings",
      );
    }
  };

  return (
    <div>
      <Form
        inputField={inputField}
        template={template}
        schema={schema}
        buttonInfo={{ label: "Save", style: "right-side" }}
        loading={loading}
        setLoading={setLoading}
        onSubmit={handleSaveSettings}
      />
    </div>
  );
}
